import AbstractAlGuestlistEditorPagesController from '../../abstracts/abstract-page-controller';

export default class AlGuestlistEditorPageLandingComponentController extends AbstractAlGuestlistEditorPagesController {

    _initFormConfig() {
        const usersStore = this.injector.get('Users');

        this._updateState({
            ...this.state,
            formConfig: {
                ...this.state.formConfig,
                landingPageLabels: _.get(usersStore, 'state.company.settings.guestlists.lp_field_labels'),
                company: this.injector.get('Users').state.company,
                mediaDirectoryUuid: _.get(usersStore, 'state.company.media.default_directories.guestlists', null)
            }
        });
    }

    /**
     * @private
     */
    _fillModelFromGuestlist() {
        this.model = _.cloneDeep({
            image_1: this.getGuestlistValue('image_1.uuid', null),
            image_2: this.getGuestlistValue('image_2.uuid', null),
            image_3: this.getGuestlistValue('image_3.uuid', null),
            teaser_image: this.getGuestlistValue('teaser_image.uuid', null),
            settings: {
                lp_text_1: this.getGuestlistValue('settings.lp_text_1'),
                lp_text_2: this.getGuestlistValue('settings.lp_text_2'),
                lp_text_3: this.getGuestlistValue('settings.lp_text_3'),
                lp_text_4: this.getGuestlistValue('settings.lp_text_4'),
                lp_text_5: this.getGuestlistValue('settings.lp_text_5'),
                lp_alert_texts: this.getGuestlistValue('settings.lp_alert_texts')
            }
        });

        for (let i = 1; i <= 30; i++) {
            const fieldDefinition = _.get(this.state.formConfig.company, `custom_${i}_guestlist`);
            if (fieldDefinition) {
                let value;
                switch (fieldDefinition.type) {
                    case 'media_file':
                    case 'media_image':
                        value = this.getGuestlistValue(`custom_${i}.uuid`, null);
                        break;
                    default:
                        value = this.getGuestlistValue(`custom_${i}`);
                        break;
                }

                this.model['custom_' + i] = value;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-landingpage-editor/pages/landing/controller.js